import { useCallback } from 'react';
import { EndPoints } from 'src/config';
import { useFetcher } from 'src/hooks/useFetcher';
import { OrganizationStatesTypes } from 'src/types';

type DashboardOrganizationResponse = OrganizationStatesTypes;

export const useDashboardOrganization = () => {
  const { fetcher, isLoading, data, error } = useFetcher<DashboardOrganizationResponse | null>(null);

  const fetchStates = useCallback(() => {
    fetcher(EndPoints.organizationStats, {
      requiredToken: true,
      method: 'GET',
    });
  }, [fetcher]);

  return {
    fetchStates,
    isLoading,
    data: data ?? null,
    connectedAgencies: data?.connectedAgencies ?? null,
    totalAgenciesPartners: data?.totalAgenciesPartners ?? 0,
    totalAgenciesTransporters: data?.totalAgenciesTransporters ?? 0,
    error,
  };
};
